var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-home"},[_c('mainHeader'),_c('div',{staticClass:"my-home-con clearfix"},[_c('div',{staticClass:"my-home-left"},[_c('myNavLeft')],1),_c('div',{staticClass:"my-home-right"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }